// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet overig API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfSUREbusinessManagementRecenteActiviteitenGetStatustellersDto } from '../model/collectionResultOfSUREbusinessManagementRecenteActiviteitenGetStatustellersDto.ts';

import type { CollectionResultOfSUREbusinessManagementRecenteActiviteitenRecenteActiviteitenRecenteActiviteitItemDto } from '../model/collectionResultOfSUREbusinessManagementRecenteActiviteitenRecenteActiviteitenRecenteActiviteitItemDto.ts';

import type { RecenteActiviteitenCountParams } from '../model/recenteActiviteitenCountParams.ts';

import type { RecenteActiviteitenGetParams } from '../model/recenteActiviteitenGetParams.ts';

import type { RecenteActiviteitenGetStatussenParams } from '../model/recenteActiviteitenGetStatussenParams.ts';

import type { Result1OfAanvragenRecenteActiviteitenGetAanvragenCountersDto } from '../model/result1OfAanvragenRecenteActiviteitenGetAanvragenCountersDto.ts';

import type { Result1OfSUREbusinessManagementRecenteActiviteitenGetMenuTellingenDto } from '../model/result1OfSUREbusinessManagementRecenteActiviteitenGetMenuTellingenDto.ts';

import type { Result1OfSchadeFeaturesRecenteActiviteitenGetSchadeCountersDto } from '../model/result1OfSchadeFeaturesRecenteActiviteitenGetSchadeCountersDto.ts';

import type { Result1OfSystemInt32 } from '../model/result1OfSystemInt32.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Inzien</li></ul>
 */
export const recenteActiviteitenGet = (
  params?: MaybeRefOrGetter<RecenteActiviteitenGetParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfSUREbusinessManagementRecenteActiviteitenRecenteActiviteitenRecenteActiviteitItemDto>(
    { url: `/api/v1/recente-activiteiten`, method: 'GET', params, signal },
    options,
  );
};

export const getRecenteActiviteitenGetQueryKey = (
  params?: MaybeRefOrGetter<RecenteActiviteitenGetParams>,
) => {
  return ['api', 'v1', 'recente-activiteiten', ...(params ? [params] : [])] as const;
};

export const getRecenteActiviteitenGetQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenGet>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RecenteActiviteitenGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recenteActiviteitenGet>>> = ({ signal }) =>
    recenteActiviteitenGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenGet>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenGet>>
>;
export type RecenteActiviteitenGetQueryError = ErrorType<void>;

export function useRecenteActiviteitenGet<
  TData = Awaited<ReturnType<typeof recenteActiviteitenGet>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RecenteActiviteitenGetParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Inzien</li></ul>
 */
export const recenteActiviteitenCount = (
  params?: MaybeRefOrGetter<RecenteActiviteitenCountParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<Result1OfSystemInt32>(
    { url: `/api/v1/recente-activiteiten/count`, method: 'GET', params, signal },
    options,
  );
};

export const getRecenteActiviteitenCountQueryKey = (
  params?: MaybeRefOrGetter<RecenteActiviteitenCountParams>,
) => {
  return ['api', 'v1', 'recente-activiteiten', 'count', ...(params ? [params] : [])] as const;
};

export const getRecenteActiviteitenCountQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenCount>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RecenteActiviteitenCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenCountQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recenteActiviteitenCount>>> = ({
    signal,
  }) => recenteActiviteitenCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenCount>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenCount>>
>;
export type RecenteActiviteitenCountQueryError = ErrorType<void>;

export function useRecenteActiviteitenCount<
  TData = Awaited<ReturnType<typeof recenteActiviteitenCount>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RecenteActiviteitenCountParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenCount>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenCountQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Inzien</li></ul>
 */
export const recenteActiviteitenGetStatussen = (
  params?: MaybeRefOrGetter<RecenteActiviteitenGetStatussenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<CollectionResultOfSUREbusinessManagementRecenteActiviteitenGetStatustellersDto>(
    { url: `/api/v1/RecenteActiviteiten/statustellers`, method: 'GET', params, signal },
    options,
  );
};

export const getRecenteActiviteitenGetStatussenQueryKey = (
  params?: MaybeRefOrGetter<RecenteActiviteitenGetStatussenParams>,
) => {
  return [
    'api',
    'v1',
    'RecenteActiviteiten',
    'statustellers',
    ...(params ? [params] : []),
  ] as const;
};

export const getRecenteActiviteitenGetStatussenQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RecenteActiviteitenGetStatussenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenGetStatussenQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>> = ({
    signal,
  }) => recenteActiviteitenGetStatussen(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenGetStatussenQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>
>;
export type RecenteActiviteitenGetStatussenQueryError = ErrorType<void>;

export function useRecenteActiviteitenGetStatussen<
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<RecenteActiviteitenGetStatussenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetStatussen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenGetStatussenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Inzien</li></ul>
 * @summary Haalt tellingen voor de menu badges op uit recente activiteiten
 */
export const recenteActiviteitenGetTellingen = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Result1OfSUREbusinessManagementRecenteActiviteitenGetMenuTellingenDto>(
    { url: `/api/v1/recente-activiteiten/tellingen`, method: 'GET', signal },
    options,
  );
};

export const getRecenteActiviteitenGetTellingenQueryKey = () => {
  return ['api', 'v1', 'recente-activiteiten', 'tellingen'] as const;
};

export const getRecenteActiviteitenGetTellingenQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenGetTellingenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>> = ({
    signal,
  }) => recenteActiviteitenGetTellingen(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenGetTellingenQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>
>;
export type RecenteActiviteitenGetTellingenQueryError = ErrorType<void>;

/**
 * @summary Haalt tellingen voor de menu badges op uit recente activiteiten
 */

export function useRecenteActiviteitenGetTellingen<
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetTellingen>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenGetTellingenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Counters</li></ul>
 * @summary Haalt de aantallen aanvragen, mutaties en maatwerken op voor het dashboard
 */
export const recenteActiviteitenGetCounters = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Result1OfAanvragenRecenteActiviteitenGetAanvragenCountersDto>(
    { url: `/api/v1/recente-activiteiten/counters`, method: 'GET', signal },
    options,
  );
};

export const getRecenteActiviteitenGetCountersQueryKey = () => {
  return ['api', 'v1', 'recente-activiteiten', 'counters'] as const;
};

export const getRecenteActiviteitenGetCountersQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetCounters>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetCounters>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenGetCountersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof recenteActiviteitenGetCounters>>> = ({
    signal,
  }) => recenteActiviteitenGetCounters(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenGetCounters>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenGetCountersQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenGetCounters>>
>;
export type RecenteActiviteitenGetCountersQueryError = ErrorType<void>;

/**
 * @summary Haalt de aantallen aanvragen, mutaties en maatwerken op voor het dashboard
 */

export function useRecenteActiviteitenGetCounters<
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetCounters>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetCounters>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenGetCountersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: RecenteActiviteiten.Counters</li></ul>
 * @summary Haalt de aantallen schades op voor het dashboard
 */
export const recenteActiviteitenGetSchadeCounters = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Result1OfSchadeFeaturesRecenteActiviteitenGetSchadeCountersDto>(
    { url: `/api/v1/recente-activiteiten/counters/schade`, method: 'GET', signal },
    options,
  );
};

export const getRecenteActiviteitenGetSchadeCountersQueryKey = () => {
  return ['api', 'v1', 'recente-activiteiten', 'counters', 'schade'] as const;
};

export const getRecenteActiviteitenGetSchadeCountersQueryOptions = <
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetSchadeCounters>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof recenteActiviteitenGetSchadeCounters>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getRecenteActiviteitenGetSchadeCountersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof recenteActiviteitenGetSchadeCounters>>
  > = ({ signal }) => recenteActiviteitenGetSchadeCounters(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recenteActiviteitenGetSchadeCounters>>,
    TError,
    TData
  >;
};

export type RecenteActiviteitenGetSchadeCountersQueryResult = NonNullable<
  Awaited<ReturnType<typeof recenteActiviteitenGetSchadeCounters>>
>;
export type RecenteActiviteitenGetSchadeCountersQueryError = ErrorType<void>;

/**
 * @summary Haalt de aantallen schades op voor het dashboard
 */

export function useRecenteActiviteitenGetSchadeCounters<
  TData = Awaited<ReturnType<typeof recenteActiviteitenGetSchadeCounters>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof recenteActiviteitenGetSchadeCounters>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getRecenteActiviteitenGetSchadeCountersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
